<template>
  <div>
    <h1 class="mb-16 section-title">
      Teameinladung
    </h1>

    <p>
      Sie haben eine Einladung für: <b>{{ team.name }}</b>
    </p>

    <div class="flex items-center border-b border-b-2 border-teal-500 py-2 w-64">
      <input
        v-model="code"
        class="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none"
        type="text"
        placeholder="Code"
        aria-label="Full name"
      >
      <button
        class="flex-shrink-0 bg-teal-500 hover:bg-teal-700 border-teal-500 hover:border-teal-700 text-sm border-4 text-white py-1 px-2 rounded"
        type="button"
        @click="addCoach()"
      >
        Team beitreten
      </button>
    </div>
  </div>
</template>

<script>
import apiService from '../api/apiService'

export default {
    name: 'TeamInvite',
    data () {
        return {
            teamId: '',
            code: '',
            team: {}
        }
    },

    async mounted () {
        this.teamId = this.$route.params.id
        this.code = this.$route.params.code
        await this.loadTeam()
    },
    methods: {

        async addCoach () {
            await apiService.addCoachToTeam(this.teamId, this.code)
            this.code = ''
        },

        async loadTeam () {
            const response = await apiService.getTeam(this.teamId)
            this.team = response.data
        }
    }
}
</script>

<style scoped>

</style>